import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { toQueryParams } from 'helpers/api';
import cookie from 'react-cookies';

export const checkTypeApi = createApi({
  reducerPath: 'checkTypeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URl}/check_types`,
    prepareHeaders: headers => {
      headers.set('Authorization', `Bearer ${cookie.load('token')}`);
      return headers;
    },
  }),
  endpoints: builder => ({
    getCheckTypes: builder.query({
      query: () => ({ url: '/' }),
      transformResponse: ({ result }) => result ?? [],
    }),
    getCheckTypesList: builder.query({
      query: params => ({
        url: `/list?${toQueryParams(params || {})}`,
        params: {},
      }),
      transformResponse: ({ result }) => result ?? [],
    }),
    getCheckGroups: builder.query({
      query: () => '/check_groups',
      transformResponse: ({ result }) => result ?? [],
    }),
    updateDefaultSupportUser: builder.mutation({
      query: ({ slug, default_support_user_id }) => ({
        url: '/update_default_support_user',
        method: 'PUT',
        body: {
          slug: slug ?? '',
          default_support_user_id:
            default_support_user_id === undefined || default_support_user_id === ''
              ? null
              : default_support_user_id,
        },
      }),
      transformResponse: ({ result }) => result ?? {},
    }),
  }),
});

export const {
  useGetCheckTypesQuery,
  useLazyGetCheckTypesListQuery,
  useGetCheckGroupsQuery,
  useUpdateDefaultSupportUserMutation,
} = checkTypeApi;
